import { ConfigTheme } from "@src/context/attributeConfig/AttributeConfigContext";
import { cfMotoThemeOptions } from "@src/theme/variants/cfmTheme";
import { gasGasThemeOptions } from "@src/theme/variants/ggTheme";
import { husqvarnaThemeOptions } from "@src/theme/variants/hqvTheme";
import { ktmThemeOptions } from "@src/theme/variants/ktmTheme";
import { mvAgustaThemeOptions } from "@src/theme/variants/mvaTheme";
import { wpPerformanceSportThemeOptions } from "@src/theme/variants/wpTheme";
import { type IntlShape } from "react-intl";

export const getDefaultOverrides = (shadowRootElement?: HTMLElement) => {
    return {
        components: {
            MuiPopover: {
                defaultProps: {
                    container: shadowRootElement,
                },
            },
            MuiPopper: {
                defaultProps: {
                    container: shadowRootElement,
                },
            },
            MuiModal: {
                defaultProps: {
                    container: shadowRootElement,
                },
            },
            MuiTooltip: {
                styleOverrides: {
                    arrow: {
                        "&::before": {
                            boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.2)",
                        },
                        color: "white",
                    },
                    tooltip: {
                        backgroundColor: "white",
                        boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.2)",
                        maxWidth: "400px",
                    },
                },
            },
        },
    };
};

export const getThemeOptionsForTheme = (attribute: ConfigTheme) => {
    switch (attribute) {
        case ConfigTheme.SPORTCAR:
        case ConfigTheme.KTM:
            return ktmThemeOptions;
        case ConfigTheme.GasGas:
            return gasGasThemeOptions;
        case ConfigTheme.Husqvarna:
            return husqvarnaThemeOptions;
        case ConfigTheme.CFMOTO:
            return cfMotoThemeOptions;
        case ConfigTheme.MVAgusta:
            return mvAgustaThemeOptions;
        case ConfigTheme.WPPerformanceSport:
            return wpPerformanceSportThemeOptions;
        default:
            return undefined;
    }
};

export const getSearchHintForTheme = (intl: IntlShape, attribute: ConfigTheme) => {
    switch (attribute) {
        case ConfigTheme.KTM:
            return intl.formatMessage({
                id: "sparePartsFinder.searchBox.hint",
                defaultMessage: "You can search for example: Super Duke, 1290, 530 EXC, etc.",
            });
        case ConfigTheme.GasGas:
            return intl.formatMessage({
                id: "sparePartsFinder.searchBox.hint.gasgas",
                defaultMessage: "You can search for example: EC 300 GP, EC 350F, etc.",
            });
        case ConfigTheme.Husqvarna:
            return intl.formatMessage({
                id: "sparePartsFinder.searchBox.hint.husqvarna",
                defaultMessage: "You can search for example: Svartpilen 801, FE 501, etc.",
            });
        case ConfigTheme.CFMOTO:
            return intl.formatMessage({
                id: "sparePartsFinder.searchBox.hint.cfmoto",
                defaultMessage: "You can search for example: 700 MT, 650NK, etc.",
            });
        case ConfigTheme.MVAgusta:
            return intl.formatMessage({
                id: "sparePartsFinder.searchBox.hint.mvagusta",
                defaultMessage: "You can search for example: Brutale 100 RR 2024, 800 NK SPORT, etc.",
            });
        case ConfigTheme.WPPerformanceSport:
            return intl.formatMessage({
                id: "sparePartsFinder.searchBox.hint.wp",
                defaultMessage: "You can search for example: APEX PRO 6500 Cartridge, etc.",
            });
        case ConfigTheme.SPORTCAR:
            return intl.formatMessage({
                id: "sparePartsFinder.searchBox.hint.sportcar",
                defaultMessage: "You can search for example: X-Bow GT-XR; X-Bow GT2, etc.",
            });
        default:
            return intl.formatMessage({
                id: "sparePartsFinder.searchBox.hint",
                defaultMessage: "You can search for example: Super Duke, 1290, 530 EXC, etc.",
            });
    }
};
